import AutoCarousel from "../Carousel";

const NewSlide2 = () => {
  return (
    <div className="w-full snap-start xl:min-h-screen xl:bg-emerald-950 flex flex-col items-center xl:justify-center py-4 xl:py-16 px-4 relative overflow-hidden">
      <div className="text-center my-6  xl:scale-90">
        <h1 className="text-white text-2xl xl:text-6xl font-normal font-stxihei">
          Unlocking the potential of <span className="text-main">HyperEVM</span>
        </h1>
      </div>

      <div className="xl:hidden flex-col items-center justify-center w-full">
        <div className="relative p-1 overflow-hidden rounded-lg flex items-center justify-center">
          <div className="absolute inset-0 z-0 animate-border-gradient"></div>
          <div className="relative z-10 w-full h-full bg-gradient-to-b from-neutral-950 to-neutral-900 shadow-lg overflow-hidden flex items-center justify-center">
            <img
              src="/images/slide2-image.png"
              alt="Trading UI"
              className="w-full object-fill"
            />
          </div>
        </div>

        <AutoCarousel />
      </div>

      <div className="hidden xl:flex w-full h-[620px] relative gap-4 justify-center items-center !font-noto-sans-thai  scale-90">
        <div className="w-auto h-full flex flex-col justify-center pb-12">
          <div className="flex flex-col justify-between items-start h-[390px] text-white">
            <div className="text-left">
              <div className="opacity-90 justify-start text-[#ADB5BD] text-base font-medium font-noto-sans-thai leading-normal">
                Unified Liquidity
              </div>
              <div className="w-72 opacity-90 justify-start text-white text-base font-semibold font-noto-sans-thai leading-normal">
                LPs deposit into a single vault and provide liquidity to all
                markets
              </div>
            </div>
            <div className="text-left">
              <div className="opacity-90 justify-start text-[#ADB5BD] text-base font-medium font-noto-sans-thai leading-normal">
                Atomic Arbitrage Opportunities
              </div>
              <div className="w-72 opacity-90 justify-start text-white text-base font-semibold font-noto-sans-thai leading-normal">
                RFX will leverage integrated precompiles enabling efficient
                funding-rate arbitrage between RFX and HL core.
              </div>
            </div>
          </div>
        </div>

        <div className="w-auto h-[620px] flex-col flex justify-center items-center">
          <div className="w-full flex justify-center mb-10">
            <div className="flex justify-between items-start w-[693px] h-full text-white">
              <div className="text-left">
                <div className="opacity-90 justify-start text-[#ADB5BD] text-base font-medium font-noto-sans-thai leading-normal">
                  Zero-Slippage Execution
                </div>
                <div className="w-72 opacity-90 justify-start text-white text-base font-semibold font-noto-sans-thai leading-normal">
                  Instantly execute size on major assets without price impact.
                </div>
              </div>
              <div className="text-left">
                <div className="opacity-90 justify-start text-[#ADB5BD] text-base font-medium font-noto-sans-thai leading-normal">
                  HypeAligned
                </div>
                <div className="w-60 opacity-90 justify-start text-white text-base font-semibold font-noto-sans-thai leading-normal">
                  Share of protocol revenue goes to HLP
                </div>
              </div>
            </div>
          </div>

          <div className="relative w-full max-w-[693px] h-[390px] p-1 overflow-hidden rounded-lg flex items-center justify-center">
            <div className="absolute inset-0 z-0 animate-border-gradient"></div>
            <div className="relative z-10 w-full h-full bg-gradient-to-b from-neutral-950 to-neutral-900 shadow-lg overflow-hidden flex items-center justify-center">
              <img
                src="/images/slide2-image.png"
                alt="Trading UI"
                class="w-[693px] h-[390px] object-fill"
              />
            </div>
          </div>

          <div className="w-full flex justify-center mt-10">
            <div className="flex justify-between items-start w-[693px] h-full text-white">
              <div className="text-left">
                <div className="opacity-90 justify-start text-[#ADB5BD] text-base font-medium font-noto-sans-thai leading-normal">
                  Create Your Own Perp Markets
                </div>
                <div className="w-72 opacity-90 justify-start text-white text-base font-semibold font-noto-sans-thai leading-normal">
                  Deploy and fund your own liquidity pool for any market
                  permissionlessly and free of cost.{" "}
                </div>
              </div>
              <div className="text-left">
                <div className="opacity-90 justify-start text-[#ADB5BD] text-base font-medium font-noto-sans-thai leading-normal">
                  Fair Pricing
                </div>
                <div className="w-72 opacity-90 justify-start text-white text-base font-semibold font-noto-sans-thai leading-normal">
                  RFX uses the median price from top exchanges to give you the
                  best prices eliminating scam liquidation wicks
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h-full flex flex-col justify-center ml-10 pb-12">
          <div className="flex flex-col justify-between items-end h-[390px] text-white">
            <div className="text-left">
              <div className="opacity-90 justify-start text-[#ADB5BD] text-base font-medium font-noto-sans-thai leading-normal">
                Native Pair Trading:
              </div>
              <div className="w-72 opacity-90 justify-start text-white text-base font-semibold font-noto-sans-thai leading-normal">
                Trade two pairs with a single position and a single funding
                rate.{" "}
              </div>
            </div>
            <div className="text-left">
              <div className="opacity-90 justify-start text-[#ADB5BD] text-base font-medium font-noto-sans-thai leading-normal">
                Diverse Collateral Options
              </div>
              <div className="w-72 opacity-90 justify-start text-white text-base font-semibold font-noto-sans-thai leading-normal">
                Use native ecosystem assets (e.g., stHype, uBTC, PURR, feUSD)
                for trading and liquidity provisioning.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSlide2;
